<div class="dialog-content-wrapper sub-event-participant-modal">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <!--    <div>-->
    <span class="title dialog-title">{{'event.sub_events' | translate}}</span>
    <button mat-button class="mat-icon-button"
            (click)="dialogRef.close()"
            aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
    <!--    </div>-->
  </mat-toolbar>

  <div class="p-24 m-0 content">
    <sub-event-participant [subEvents]="subEvents" [participants]="participants"
                           [eventId]="eventId" [eventData]="eventData"></sub-event-participant>
  </div>
</div>
